import axios from "axios";
// const baseUrl = "http://localhost:3000/api/automatiq";
const baseUrl = "https://eagleanalytix.com/api/automatiq";

class APIHandler {
  post(route, data) {
    try {
      const user = localStorage.getItem("userData") || "{}";
      const { token } = JSON.parse(user || "");
      const response = axios.post(
        `${baseUrl}/${route}`,
        { data },
        {
          headers: { token },
        }
      );
      if (response.status === 401) console.log("Unautorized");
      return response;
    } catch (error) {
      console.log("Something went wrong.", error);
      return { status: false, message: "Something went wrong." };
    }
  }

  get(route) {
    try {
      const user = localStorage.getItem("userData") || "{}";
      const { token } = JSON.parse(user || "");
      const response = axios.get(`${baseUrl}/${route}`, {
        headers: { token },
      });
      if (response.status === 401) console.log("Unautorized");
      return response;
    } catch (error) {
      console.log("Something went wrong.", error);
      return { status: false, message: "Something went wrong." };
    }
  }
}

export default APIHandler;
